"use client";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi,
} from "@/components/ui/carousel";
import React from "react";
import ReviewCard from "./review-card";
import Autoplay from "embla-carousel-autoplay";
import { cn } from "@/lib/utils";
import { Button } from "./ui/button";
import { useTranslations } from "next-intl";
import { BlurFade } from "./ui/blur-fade";

export function Reviews() {
  const t = useTranslations("review");
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);

  React.useEffect(() => {
    if (!api) {
      return;
    }

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });

    window.addEventListener("resize", () => {
      setCount(api.scrollSnapList().length);
    });
  }, [api]);

  return (
    <Carousel
      setApi={setApi}
      plugins={[
        Autoplay({
          delay: 10000,
        }),
      ]}
      className="flex flex-col gap-4"
    >
      <CarouselContent>
        {[1, 2, 3].map((value) => (
          <CarouselItem
            key={`review-${value}`}
            className="md:basis-1/2 lg:basis-1/3"
          >
            <BlurFade
              delay={parseFloat(`0.${value * 1.2}`)}
              className="h-full"
              inView
              direction="left"
            >
              <ReviewCard
                website={"Recensione Google"}
                author={t(`review${value}Name`)}
                text={t(`review${value}Content`)}
                score={5}
              />
            </BlurFade>
          </CarouselItem>
        ))}
      </CarouselContent>
      {count != 1 && (
        <div className="mx-auto flex items-center gap-2">
          {[...Array(count).keys()].map((page) => {
            return (
              <Button
                variant={"ghost"}
                onClick={() => api?.scrollTo(page)}
                key={`review-page-dot-${page}`}
                className={cn("rounded-full border-2 !w-3 !h-3 p-0", {
                  "bg-white": page + 1 == current,
                })}
              >
                <span className="sr-only">
                  {t("goToPage", { page: page + 1 })}
                </span>
              </Button>
            );
          })}
        </div>
      )}
    </Carousel>
  );
}
